import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-63" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-64" data-mp="1uy2xkxid372q">
        <h2 className="chalk-underline font-display font-bold uppercase text-white text-4xl sm:text-6xl" data-id="element-65" data-mp="1v05w65xky8j2">
          Stop improvising.{' '}
          <span className="text-gold" data-id="element-66" data-mp="1l0f0w2173phx">Walk onto the field ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-67" data-mp="1g9otykd4fel4">
          A full season of ready-to-run softball practices — warm-ups,
          drills, game situations and printable worksheets. Built on the
          4-Block Practice System, even if it&apos;s your first season coaching.
        </p>

        <div className="mt-7" data-id="element-68" data-mp="12a70hrovrd5f">
          <Countdown size="sm" tone="dark" data-id="element-69" data-mp="128cial4ztz51" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-70" data-mp="xauibk8yeu96">
          <div data-id="element-71" data-mp="3ve3sd08gtu86">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-72" data-mp="3vdkblmujxbvq">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-white" data-id="element-73" data-mp="3liabj4nprekl">
              Softball Season-Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-74" data-mp="i0ing1cp7ero">
            <span className="text-[15px] text-white/60 line-through" data-id="element-75" data-mp="i11uuo4q2krg">$90</span>
            <span className="font-display text-5xl leading-none text-white" data-id="element-76" data-mp="myk6ima4je35">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-77" data-mp="84f9ly8hhrow">
          <CtaButton data-id="element-78" data-mp="d0mhvxocrfa0">Yes, I want my season planned — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-79" data-mp="2sstkaabty3py">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-80" data-mp="148o07ecbg2b0">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-81" data-mp="14b0g7lyik2lf" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}